/**
 * Matches an object by slug and objects enabled property
 * @param {Array} arr - The array of objects to search
 *   @param {Object} arr.obj - An object that has both slug and enabled keys
 * @param {Object} item - Object containing slug and enabled keys to match against
 */
export function setEnabled (arr, item) {
  arr.find((el) => {
    if (el.slug === item.slug) {
      el.enabled = item.enabled;
    }
  });
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/store/services/setEnabled.js